/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsCustomRegistrationFieldDtoSchema = z.object({
  key: z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-zA-Z0-9_]+$/),
  label: z.string().min(1).max(200),
  type: z.string().min(1),
  required: z.optional(z.boolean()),
  options: z.array(z.string()).nullish(),
});
